 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import BUNDLE_COVER from '@/components/bundle_cover'
 import EBB from '@/components/ebb'
 import LOVE_1 from '@/components/love_1'
 import BUNDLE_TITLE from '@/components/bundle_title'
 import BUNDLE_CONTENT from '@/components/bundle_content'
 import BOOK11COVER from '@/components/Book1/1cover'
 import BOOK12TITLE_PAGE from '@/components/Book1/2title_page'
 import BOOK14START from '@/components/Book1/4start'
 import BOOK15CHAP2 from '@/components/Book1/5chap2'
 import BOOK16CHAP3 from '@/components/Book1/6chap3'
 import BOOK17CHAP4 from '@/components/Book1/7chap4'
 import BOOK18CHAP5 from '@/components/Book1/8chap5'
 import BOOK19CHAP6 from '@/components/Book1/9chap6'
 import BOOK110CHAP7 from '@/components/Book1/10chap7'
 import BOOK111CHAP8 from '@/components/Book1/11chap8'
 import BOOK112CHAP9 from '@/components/Book1/12chap9'
 import BOOK113CHAP10 from '@/components/Book1/13chap10'
 import BOOK114CHAP11 from '@/components/Book1/14chap11'
 import BOOK115CHAP12 from '@/components/Book1/15chap12'
 import BOOK116CHAP13 from '@/components/Book1/16chap13'
 import BOOK117CHAP14 from '@/components/Book1/17chap14'
 import BOOK118CHAP15 from '@/components/Book1/18chap15'
 import BOOK119CHAP16 from '@/components/Book1/19chap16'
 import BOOK21COVER from '@/components/Book2/1cover'
 import BOOK22TITLE_PAGE from '@/components/Book2/2title_page'
 import BOOK24START from '@/components/Book2/4start'
 import BOOK25CHAP2 from '@/components/Book2/5chap2'
 import BOOK26CHAP3 from '@/components/Book2/6chap3'
 import BOOK27CHAP4 from '@/components/Book2/7chap4'
 import BOOK28CHAP5 from '@/components/Book2/8chap5'
 import BOOK29CHAP6 from '@/components/Book2/9chap6'
 import BOOK210CHAP7 from '@/components/Book2/10chap7'
 import BOOK211CHAP8 from '@/components/Book2/11chap8'
 import BOOK212CHAP9 from '@/components/Book2/12chap9'
 import BOOK213CHAP10 from '@/components/Book2/13chap10'
 import BOOK214CHAP11 from '@/components/Book2/14chap11'
 import BOOK215CHAP12 from '@/components/Book2/15chap12'
 import BOOK216CHAP13 from '@/components/Book2/16chap13'
 import BOOK217CHAP14 from '@/components/Book2/17chap14'
 import BOOK218CHAP15 from '@/components/Book2/18chap15'
 import BOOK31COVER from '@/components/Book3/1cover'
 import BOOK32PAGE from '@/components/Book3/2page'
 import BOOK34PAGE from '@/components/Book3/4page'
 import BOOK35PAGE from '@/components/Book3/5page'
 import BOOK36PAGE from '@/components/Book3/6page'
 import BOOK37PAGE from '@/components/Book3/7page'
 import BOOK38PAGE from '@/components/Book3/8page'
 import BOOK39PAGE from '@/components/Book3/9page'
 import BOOK310PAGE from '@/components/Book3/10page'
 import BOOK311PAGE from '@/components/Book3/11page'
 import BOOK312PAGE from '@/components/Book3/12page'
 import BOOK313PAGE from '@/components/Book3/13page'
 import BOOK314PAGE from '@/components/Book3/14page'
 import BOOK315PAGE from '@/components/Book3/15page'
 import BOOK316PAGE from '@/components/Book3/16page'
 import BOOK317PAGE from '@/components/Book3/17page'
 import BOOK318PAGE from '@/components/Book3/18page'
 import BOOK319PAGE from '@/components/Book3/19page'
 import BOOK320PAGE from '@/components/Book3/20page'
 import BOOK321PAGE from '@/components/Book3/21page'
 import BOOK322PAGE from '@/components/Book3/22page'
 import BOOK323PAGE from '@/components/Book3/23page'
 import BOOK324PAGE from '@/components/Book3/24page'
 import BOOK325PAGE from '@/components/Book3/25page'
 import BOOK41COVER from '@/components/Book4/1cover'
 import BOOK42TITLE_PAGE from '@/components/Book4/2title_page'
 import BOOK44START from '@/components/Book4/4start'
 import BOOK45CHAP2 from '@/components/Book4/5chap2'
 import BOOK46CHAP3 from '@/components/Book4/6chap3'
 import BOOK47CHAP4 from '@/components/Book4/7chap4'
 import BOOK48CHAP5 from '@/components/Book4/8chap5'
 import BOOK49CHAP6 from '@/components/Book4/9chap6'
 import BOOK410CHAP7 from '@/components/Book4/10chap7'
 import BOOK411CHAP8 from '@/components/Book4/11chap8'
 import BOOK412CHAP9 from '@/components/Book4/12chap9'
 import BOOK413CHAP10 from '@/components/Book4/13chap10'
 import BOOK414CHAP11 from '@/components/Book4/14chap11'
 import BOOK415CHAP12 from '@/components/Book4/15chap12'
 import BOOK416CHAP13 from '@/components/Book4/16chap13'
 import BOOK417CHAP14 from '@/components/Book4/17chap14'
 import BOOK418CHAP15 from '@/components/Book4/18chap15'
 import BOOK419CHAP16 from '@/components/Book4/19chap16'
 import BOOK420CHAP17 from '@/components/Book4/20chap17'
 import BOOK421CHAP18 from '@/components/Book4/21chap18'
 import BOOK422CHAP19 from '@/components/Book4/22chap19'
 import BOOK423CHAP20 from '@/components/Book4/23chap20'
 import BOOK424CHAP21 from '@/components/Book4/24chap21'
 import BOOK425CHAP22 from '@/components/Book4/25chap22'
 import BOOK426CHAP23 from '@/components/Book4/26chap23'
 import BOOK427CHAP24 from '@/components/Book4/27chap24'
 import BOOK428CHAP25 from '@/components/Book4/28chap25'
 import BOOK429CHAP26 from '@/components/Book4/29chap26'
 import BOOK430CHAP27 from '@/components/Book4/30chap27'
 import BOOK431CHAP28 from '@/components/Book4/31chap28'
 import BOOK432CHAP29 from '@/components/Book4/32chap29'
 import BOOK433CHAP30 from '@/components/Book4/33chap30'
 import BOOK434CHAP31 from '@/components/Book4/34chap31'
 import BOOK435CHAP32 from '@/components/Book4/35chap32'
 import BOOK436CHAP33 from '@/components/Book4/36chap33'
 import BOOK437CHAP34 from '@/components/Book4/37chap34'
 import BOOK438CHAP35 from '@/components/Book4/38chap35'
 import BOOK439CHAP36 from '@/components/Book4/39chap36'
 import BOOK440CHAP37 from '@/components/Book4/40chap37'
 import BOOK441CHAP38 from '@/components/Book4/41chap38'
 import BOOK442CHAP39 from '@/components/Book4/42chap39'
 import BOOK443CHAP40 from '@/components/Book4/43chap40'
 import LOVE_2 from '@/components/love_2'
 import COMONAUTHOR from '@/components/Comon/author'
 import COMONCOPYRIGHT from '@/components/Comon/copyright'
 import COMONBACKAD_1 from '@/components/Comon/backad_1'
 import ORIMAD from '@/components/ORIMad'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/bundle_content",
 			"name" : "bundle_content",
 			"component" : BUNDLE_CONTENT
 		},
 		{
 			"path" : "/Book1/1cover",
 			"name" : "Book1/1cover",
 			"component" : BOOK11COVER
 		},
 		{
 			"path" : "/Book1/2title_page",
 			"name" : "Book1/2title_page",
 			"component" : BOOK12TITLE_PAGE
 		},
 		{
 			"path" : "/Book1/4start",
 			"name" : "Book1/4start",
 			"component" : BOOK14START
 		},
 		{
 			"path" : "/Book1/5chap2",
 			"name" : "Book1/5chap2",
 			"component" : BOOK15CHAP2
 		},
 		{
 			"path" : "/Book1/6chap3",
 			"name" : "Book1/6chap3",
 			"component" : BOOK16CHAP3
 		},
 		{
 			"path" : "/Book1/7chap4",
 			"name" : "Book1/7chap4",
 			"component" : BOOK17CHAP4
 		},
 		{
 			"path" : "/Book1/8chap5",
 			"name" : "Book1/8chap5",
 			"component" : BOOK18CHAP5
 		},
 		{
 			"path" : "/Book1/9chap6",
 			"name" : "Book1/9chap6",
 			"component" : BOOK19CHAP6
 		},
 		{
 			"path" : "/Book1/10chap7",
 			"name" : "Book1/10chap7",
 			"component" : BOOK110CHAP7
 		},
 		{
 			"path" : "/Book1/11chap8",
 			"name" : "Book1/11chap8",
 			"component" : BOOK111CHAP8
 		},
 		{
 			"path" : "/Book1/12chap9",
 			"name" : "Book1/12chap9",
 			"component" : BOOK112CHAP9
 		},
 		{
 			"path" : "/Book1/13chap10",
 			"name" : "Book1/13chap10",
 			"component" : BOOK113CHAP10
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js